var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_order-status-label"},[_c('span',{staticClass:"d-inline-block",class:_vm.color,staticStyle:{"width":"10px","height":"10px","border-radius":"50%"}}),_vm._v(" "+_vm._s(_vm.statusText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }